module.exports = __webpack_public_path__ + "static/img/peizi_logo.3e6d6d3.gif";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/peizi_logo.gif
// module id = RmGR
// module chunks = 1